import { DatePicker, Input, Table, Modal, Button } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpPost, httpUrl, serverUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";
import { numberFormat } from "../../util";
import moment from "moment";

const Search = Input.Search;
const { RangePicker } = DatePicker;

const paymentStatusCode = ['ALL', 'SUCCESS', 'CANCELED', 'FAIL', 'INVALID_AMOUNT', 'INVALID_FRANCHISE', 'INVALID_USER', 'INVALID_PAYTYPE', 'INSUFFICIENT_BALANCE', 'UID_DUP', 'VERIFY_FAIL', 'INVALID_UUID', 'REQUEST', 'NO_TICKER', 'PRICE_OUT_OF_BOUND', 'INVALID_AUTH'];
const paymentStatusString = {
  ALL: '전체보기',
  SUCCESS: '성공',
  CANCELED: '취소',
  FAIL: '시스템오류',
  INVALID_AMOUNT: '금액오류',
  INVALID_FRANCHISE: '상점오류',
  INVALID_USER: '사용자오류',
  INVALID_PAYTYPE: '결제유형오류',
  INSUFFICIENT_BALANCE: '잔액부족',
  UID_DUP: '결제키중복',
  VERIFY_FAIL: '로마켓인증실패',
  INVALID_UUID: 'UUID오류',
  REQUEST: '결제중',
  NO_TICKER: '가격정보오류',
  PRICE_OUT_OF_BOUND: '가격범위초과',
  INVALID_AUTH: '유효하지 않은 인증'
}
const payType = [
  '',
  '복합결제',
  '카드결제',
  '현금결제',
  '제로페이',
  '기타',
]
class RomarketPaymentLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tables: [],
      searchText: '',
      searchStatus: 'ALL',
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getList());
  };

  onSearch = (value) => {
    this.setState(
      {
        searchText: value
      },
      () => {
        this.getList();
      }
    );
  };
  onStatus = (value) => {
    this.setState(
      {
        searchStatus: value
      },
      () => {
        this.getList();
      }
    );
  };
  getList = () => {
    let pageNum = this.state.pagination.current;
    httpGet(httpUrl.romarketPaymentLogList,[10,pageNum,this.state.searchText,this.state.searchStatus],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        tables: res.data.list,
        pagination,
      });
    });
  };

  render() {
    const { tables } = this.state;
    const columns = [
      {
        title: "결제키",
        dataIndex: "uuid",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "지갑 ID",
        dataIndex: "infWalletId",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "상점 ID",
        dataIndex: "infFranchiseId",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "총가격(원)",
        dataIndex: "totalPrice",
        className: "support-column-number fs-15 lh-21",
        render: value => numberFormat(value)
      },
      {
        title: "결제유형",
        dataIndex: "payType",
        className: "support-column-number fs-15 lh-21",
        render: value => payType[value]
      },
      {
        title: "채굴비율(%)",
        dataIndex: "miningRatio",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? value.toFixed(2) : ''
      },
      {
        title: "채굴량(ROM)",
        dataIndex: "miningAmount",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? (value/1000000000).toFixed(4) : ''
      },
      {
        title: "보상비율(%)",
        dataIndex: "rewardRatio",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? value.toFixed(2) : ''
      },
      {
        title: "보상량(ROM)",
        dataIndex: "rewardAmount",
        className: "support-column-number fs-15 lh-21",
        render: value => value ? (value/1000000000).toFixed(4) : ''
      },
      {
        title: "결제일시",
        dataIndex: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: value => moment(value).format('YYYY-MM-DD hh:mm:ss')
      },
      {
        title: "상태",
        dataIndex: "status",
        className: "support-column-number fs-15 lh-21",
        render: value => paymentStatusString[value]
      }
    ];
    

    return (
      <div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px', color: 'red'}}>
          </div>
          <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>
            <Search
              placeholder={
                "검색어를 입력해주세요."
              }
              enterButton="검색"
              allowClear
              onSearch={this.onSearch}
              style={{ width: 400 }}
            />
            <div style={{paddingLeft: '20px'}}>상태:</div>
            <SelectBox
              value={paymentStatusString[this.state.searchStatus]}
              code={paymentStatusCode}
              codeString={paymentStatusString}
              onChange={(value) => {
                if (value !== this.state.searchStatus) {
                  this.onStatus(value);
                }
              }}
              style={{ width: "200px", marginLeft: "10px" }}
            />
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.status == 'SUCCESS' ? "blue" : record.status == 'CANCELED' ? "gray" : "")}
          dataSource={tables}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default RomarketPaymentLog;
